import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import auth from "../../Account/Auth";

function PageNotFound() {
  const loggedIn = auth.isSessionValid();
  const { t } = useTranslation(["404"]);

  try {
    window.tidioChatApi.show();
  } catch {}

  useEffect(() => {
    document.title = `Calendbook - 404`;
  }, []);

  return (
    <section className="tw-flex tw-items-center tw-h-full">
      <div className="tw-w-full tw-py-8 tw-px-4 tw-mx-auto tw-max-w-screen-xl lg:tw-py-16 lg:tw-px-6">
        <div className="tw-mx-auto tw-max-w-screen-sm tw-text-center">
          <h1 className="tw-mb-4 tw-text-5xl tw-tracking-tight tw-font-extrabold tw-text-primary-600">
            {t("title")}
          </h1>
          <p className="tw-mb-8 tw-font-medium tw-text-gray-500 sm:tw-text-2xl dark:tw-text-gray-400">
            {t("description")}
          </p>
          {!loggedIn && (
            <button
              className="tw-border tw-border-primary-500 tw-bg-primary-600 tw-text-white tw-cursor-pointer tw-p-3 tw-rounded-lg"
              onClick={() => (window.location.href = "/login")}
            >
              {t("signIn")}
            </button>
          )}
          {loggedIn && (
            <button
              className="tw-border tw-border-primary-500 tw-bg-primary-600 tw-text-white tw-cursor-pointer tw-p-3 tw-rounded-lg"
              onClick={() => (window.location.href = "/")}
            >
              {t("dashboard")}
            </button>
          )}
        </div>
      </div>
    </section>
  );
}

export default PageNotFound;
